<script setup>
import { SKELETON_SIZES } from '@/utils/components-configurations/skeleton-item'

import SkeletonItem from '@/components/ui/SkeletonLoaders/SkeletonItem'

defineOptions({
  name: 'ElementProgressTableLoader'
})

defineProps({
  columnCount: {
    type: Number,
    default: 3
  }
})
</script>

<template>
  <div class="eptl-Loader">
    <div class="eptl-Table">
      <div v-for="cell in columnCount" :key="cell" class="eptl-Cell">
        <SkeletonItem :size="SKELETON_SIZES.XS" border-radius="4px" width="80%" />
      </div>
      <div v-for="cell in columnCount" :key="cell" class="eptl-Cell eptl-Cell-value">
        <SkeletonItem :size="SKELETON_SIZES.XS" border-radius="4px" width="35px" />

        <SkeletonItem :size="SKELETON_SIZES.XS" border-radius="4px" width="27px" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.eptl-Loader {
  padding-inline: 24px;
}
.eptl-Table {
  border-right: 1px solid $grey-3-next;
  border-left: 1px solid $grey-3-next;
  background-color: $grey-3-next;
  --skeleton-height: 14px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(v-bind(columnCount), 1fr);
  gap: 1px;
}

.eptl-Cell {
  background-color: $white;
  min-height: 32px;
  padding-inline: 16px 6px;
  display: flex;

  &:not(&-value) {
    height: 32px;
    align-items: center;
    justify-content: flex-start;
  }

  &-value {
    height: 64px;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
  }
}
</style>
